import { render, staticRenderFns } from "./scenarioLeft.vue?vue&type=template&id=380d8874&"
import script from "./scenarioLeft.vue?vue&type=script&lang=js&"
export * from "./scenarioLeft.vue?vue&type=script&lang=js&"
import style0 from "./scenarioLeft.vue?vue&type=style&index=0&id=380d8874&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports